export default __webpack_public_path__ + "static/media/icon-evolution.d76be4b1.svg";